import Relay from 'react-relay';

export default class AddCustomerMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{inviteCustomer}`;
  }

  getVariables() {
    return {
      userId: this.props.userId,
      conversationId: this.props.conversationId,
      email: this.props.email,
      name: this.props.name
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on CreateConversationPayload {
        user {
          pid
          email
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        user: this.props.userRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddCustomerMutation.js
 **/